import { Table } from '@nimbus-ds/components';
import { CustomHeaderCell } from 'commons/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface PartnersListDesktopHeaderProps {
  hasPartnerAdminAccess?: boolean;
}

function PartnersListDesktopHeader({
  hasPartnerAdminAccess,
}: PartnersListDesktopHeaderProps) {
  const t = useTranslationConfigurations('usersListPage.table');
  return (
    <Table.Head>
      <CustomHeaderCell width="144px" color="neutral-textHigh">
        {t('name')}
      </CustomHeaderCell>
      <CustomHeaderCell
        width={{ md: '140px', lg: '180px', xl: '220px' }}
        color="neutral-textHigh"
      >
        {t('email')}
      </CustomHeaderCell>
      <CustomHeaderCell width="auto" color="neutral-textHigh">
        {t('permissions')}
      </CustomHeaderCell>
      <CustomHeaderCell
        width={hasPartnerAdminAccess ? '220px' : '88px'}
        color="neutral-textHigh"
      >
        {t('actions')}
      </CustomHeaderCell>
    </Table.Head>
  );
}

export default PartnersListDesktopHeader;
